import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminUserDetailKeys } from "Api/Queries/User/useAdminUserDataQuery";
import { USERS_LIST_QUERY_KEY } from "Api/Queries/User/useUsersListQuery";
import { usersNotVerifiedKeys } from "Api/Queries/User/useUsersNotVerifiedQuery";
import { getVerificationsQueryKey } from "Api/Queries/Verifications/useVerificationsQuery";
import {
  type UserAdminDetailDto,
  postUsersAdminDetail,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (parameters: UserAdminDetailDto) => void;
  onError?: (error: unknown) => void;
};

export const useUpdateUserMutation = ({ onSuccess, onError }: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (data: UserAdminDetailDto) => postUsersAdminDetail(data),
    ),
    onSuccess: (_, parameters: UserAdminDetailDto) => {
      queryClient.invalidateQueries({
        queryKey: adminUserDetailKeys.detailByUserID(parameters.userID),
      });
      queryClient.invalidateQueries({
        queryKey: getVerificationsQueryKey(parameters.userID),
      });
      queryClient.invalidateQueries({
        queryKey: [USERS_LIST_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: usersNotVerifiedKeys.all,
      });
      onSuccess?.(parameters);
    },
    onError: (e) => onError?.(e),
  });
};
